import { useSelector } from "react-redux";
import useGlobalKeyAccountsAccess from "../hooks/useGlobalKeyAccountsAccess";
import ModuleAccessDenied from "./ModuleAccessDenied";
import PageLoadingFallback from "./PageLoadingFallback";

/**
 * Route guard for the Global Key Accounts page — the per-USER sibling of
 * WorkflowVisibilityRoute (which gates per workspace). The capability is
 * decided server-side (dashmote staff + Firestore allowlist, red_bull_global
 * only) and probed via useGlobalKeyAccountsAccess, so the route can never be
 * more permissive than the data modes it fronts: a direct URL from a
 * non-allowlisted account renders the in-shell Access Denied page, and even a
 * bypassed guard would only reach 403ing backend modes.
 *
 * @param {{ children: React.ReactNode }} props
 */
const GlobalKeyAccountsRoute = ({ children }) => {
  const selectedClient = useSelector((s) => s.auth.selectedWorkspace?.key ?? null);
  const { allowed, status } = useGlobalKeyAccountsAccess(selectedClient);

  if (!selectedClient) return <ModuleAccessDenied />;
  // Deciding while the probe is in flight would flash Access Denied for
  // allowlisted users on every load; the probe fails closed on error.
  if (status === "loading") return <PageLoadingFallback />;
  if (allowed) return children;
  return <ModuleAccessDenied />;
};

export default GlobalKeyAccountsRoute;
